import React from 'react';

export type PaddingSize = 'xsmall' | 'small' | 'medium' | 'large' | 'none';

interface PaddedProps {
    vertical: PaddingSize;
    horizontal: PaddingSize;
    children: React.ReactNode;
    fullHeight?: boolean;
    className?: string;
    overflow?: 'hidden' | 'visible' | 'scroll' | 'auto';
}

const getPadding = (size: PaddingSize) => {
    switch (size) {
        case 'xsmall':
            return '4px';
        case 'small':
            return '7px';
        case 'medium':
            return '14px';
        case 'large':
            return '28px';
        case 'none':
            return '0';
        default:
            return '14px';
    }
};

const Padded: React.FC<PaddedProps> = ({
    vertical,
    horizontal,
    children,
    fullHeight = true,
    className = '',
    overflow = 'visible',
}) => {
    return (
        <div
            className={className}
            style={{
                padding: `${getPadding(vertical)} ${getPadding(horizontal)}`,
                height: fullHeight ? '100%' : undefined,
                overflow,
            }}
        >
            {children}
        </div>
    );
};

export default Padded;
